const de = {
  common: {
    wallet: "Geldbörse",
    playPage: "spielen",
    minTop: "Mindestbetrag beträgt $10",
    maxTop: "Höchstbetrag beträgt $500",
    website: "Webseite",
    signOut: "abmelden",
    hidden: "versteckt",
    victory: "Sieg",
    wentWrong: "etwas ist schief gelaufen, Umleitung",
    stakeLabel: "Einsatz",
    howDoes: "wie funktioniert das?",
    continue: "Fortfahren",
    continueWithGoogle: "Mit Google fortfahren",
    continueWithApple: "Mit Apple fortfahren",
    termsOfService: "Nutzungsbedingungen",
    privacyPolicy: "Datenschutzerklärung",
    termsOfServiceFooter: "Nutzungsbedingungen",
    privacyPolicyFooter: "Datenschutzerklärung",
    verificationCode: "Verifizierungscode",
    verify: "verifizieren",
    account: "Konto",
    error: "ein Fehler ist aufgetreten\n",
    checkBackLater: "später nachschauen",
    looking: "suchend...",
    yes: "ja",
    no: "nein",
    pleaseSelect: "Bitte auswählen\n",
    disclaimer: "indem Sie fortfahren stimmen Sie unseren\n",
    and: "und",
  },
  endOfGame: {
    wonByCheckmate: "gewonnen durch Schachmatt",
    lostOnTime: "auf Zeit verloren",
    resigns: "gibt auf",
    gameDrawnByAgreement: "Spiel durch Vereinbarung gezogen",
    abandonedTheGame: "das Spiel aufgegeben",
    gameAborted: "Spiel abgebrochen",
    gameDrawnByStalemate: "Spiel durch Patt gezogen",
    gameDrawnByFiftyMoveRule: "Spiel durch 50-Zug-Regel gezogen",
    gameDrawnByInsufficientMaterial: "Spiel durch unzureichendes Material gezogen",
    gameDrawnByThreefoldRepetition: "Spiel durch dreifache Wiederholung gezogen",
    draw: "remis",
    victory: "Sieg",
    defeat: "Niederlage",
    aborted: "abgebrochen",
    white: "weiß",
    black: "schwarz",
    inspectBoard: "Brett ansehen",
    returnToEndOfGameModal: "fortsetzen",
  },
  byPhone:{
    continueOnPhone: "fortfahren auf\ndem Telefon",
    or: "oder",
    continueOnWeb: "fortfahren im\nBrowser",
    disclaimer: "geeignet, wenn Sie ein Bild Ihrer ID auf der Festplatte haben"
  },
  signUp: {
    email: "E-Mail",
    username: "Benutzername",
    usernameInvalid: "Benutzername ungültig",
    emailInvalid: "ungültige E-Mail",
    login: "anmelden",
    continueWithPhone: "mit Telefonnummer fortfahren",
    tickBoxes: "lassen Sie uns einige\nKästchen ankreuzen",
    confirm: "Ich bestätige, dass\n",
    resideIn: "Ich wohne in\n",
    notPEP: "Ich bin keine politisch exponierte Person (PEP), kein Familienmitglied oder kein bekannter Mitarbeiter einer PEP\n",
    purpose: "Der Zweck und die Art meiner Beziehung zu Gambit besteht ausschließlich darin, den Service zur Unterhaltung zu nutzen\n",
    soleBenefit: "Ich werde den Service ausschließlich zu meinem Vorteil nutzen und es gibt keinen anderen Begünstigten\n",
  },
  identity: {
    beingVerified: "Identität\nwird überprüft",
    verified: "verifiziert\n",
    failed: "Verifizierung\ngescheitert",
  },
  payment: {
    failed: "Zahlung fehlgeschlagen.\nBitte versuchen Sie es erneut",
    successful: "Zahlung\nerfolgreich!",
    toppedUp: "Sie sind\naufgefüllt!",
    topUp: "aufladen\n",
    payWith: "bezahlen mit...\n",
  },
  gameplay: {
    play: "spielen\n",
    challenge: "fordert Sie zu einem",
    gameWorth: "Spiel wert\n",
    whatsYourNumber: "was ist Ihre\nNummer?",
    receiveCode: "Sie erhalten in Kürze einen Verifizierungs\ncode",
    matchedOpponent: "Sie werden einem Gegner mit ähnlichem Rating zugewiesen.",
    stake: {
      total: "Der gesamte Einsatz beträgt den unten ausgewählten Betrag.",
      contribution: "Sie tragen etwa die Hälfte dieses Betrags bei.",
      weakerOpponent: "Wenn Sie gegen einen schwächeren Gegner spielen, zahlen Sie einen größeren Anteil des Einsatzes.",
      strongerOpponent: "Wenn Sie gegen einen stärkeren Gegner spielen, zahlen Sie einen kleineren Anteil des Einsatzes.",
    },
    supportInfo: "Besuchen Sie unseren Support für weitere Informationen.\n",
    continueBrowser: "fortfahren im\nBrowser",
    continuePhone: "fortfahren auf\ndem Telefon",
    getStarted: "lassen Sie uns\nbeginnen",
    sentText: "wir haben Ihnen\neine SMS gesendet",
    enterReceivedCode: "geben Sie den erhaltenen\nVerifizierungscode ein",
    wrongCode: "falscher Code, versuchen Sie es erneut\n",
    secPerMove: "Sek/Zug",
    resign: {
      prompt: "Sind Sie sicher, dass Sie aufgeben möchten?",
    },
    draw: {
      offer: "Remisangebot akzeptieren?",
    },
    rating: "Bewertung\n",
    balance: "Guthaben\n",
    rematch: "Revanche\n",
    newOpponent: "neuer Gegner\n",
    home: "Start\n",
    rematchOffer: "Ihr Gegner bietet eine Revanche an. Akzeptieren?",
    leaveGame: "Sie spielen derzeit ein Spiel. Sind Sie sicher, dass Sie gehen möchten?",
    room: "Raum:\n",
    gameTypes: {
      bullet: {
        title: "bullet\n",
        description: "Adrenalin-Schach. Sie und Ihr Gegner haben jeweils nur 1 Minute, um das Spiel zu gewinnen.",
      },
      blitz: {
        title: "blitz\n",
        description: "Sie und Ihr Gegner haben jeweils 3 Minuten, um das Spiel zu gewinnen.",
      },
    },
    stakes: {
      unlockNext: "spielen Sie {amount} weitere Spiele, um den nächsten Einsatz freizuschalten",
      allUnlocked: "Sie haben alle Einsätze freigeschaltet",
    },
    withdraw: "auszahlen\n",
  },
  puzzle: {
    begin: "beginnen",
    next: "nächste",
    unavailableInYourRegion: "nicht verfügbar",
    puzzle: "rätsel",
    whiteToPlay: "weiß am Zug",
    blackToPlay: "schwarz am Zug",
    time: "zeit",
    solution: "lösung",
    somethingWentWrong: "etwas ist schiefgelaufen",
    rating: "bewertung",
    credits: "credits",
    puzzleFailed: "niederlage",
    puzzleSolved: "sieg",
    correct: "korrekte lösung",
    incorrect: "falsche lösung",
    youRanOutOfTime: "ihre zeit ist abgelaufen",
    puzzleDescription: "Sie haben 10 Sekunden + 2 Sekunden/Zug, um ein Rätsel zu lösen.",
    creditsLeft: "verbleibende Credits",
    refillIn: "wieder auffüllen in",
    lastPuzzle: "Das ist dein letztes Rätsel, schau später wieder vorbei für mehr.",
    outOfCredits: "Du hast keine Credits mehr, schau später wieder vorbei.",
    locationPrompt: "Wir benötigen Ihren Standort, um fortzufahren. Wenn blockiert, bitte wieder aktivieren:",
    locationInstructions: "Klicken Sie auf das Symbol in der Adressleiste, wählen Sie 'Immer erlauben' und aktualisieren Sie die Seite",
    creditsError: "Fehler beim Laden der Credits",
    moves: "Züge:",
  },
};

export {de};